<template>
  <div data-test-id="DailyCasesChartContainerComponent" class="casechart">
    <DailyCasesChart :labels="labels" :chart-data="chartData" :styles="{ height: '250px', position: 'relative' }" />
  </div>
</template>

<script>
import DailyCasesChart from "@/Dashboard/components/DailyCasesChart";

export default {
  name: "DailyCasesChartContainer",
  components: { DailyCasesChart },
  props: {
    chartData: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped lang="css">
.casechart {
  max-width: 1000px;
  max-height: 300px;
  margin: auto;
  margin-top: 15px;
}
</style>
